import { HOME_SCHEMAS, ICON_OPTIONS } from "./home-schemas";

const ABOUT_SCHEMAS = {
  hero: {
    title: "Section 1 — Hero",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "title_post", label: "Title — after highlight", type: "text" },
      { name: "paragraph1", label: "Paragraph 1", type: "textarea" },
      { name: "paragraph2", label: "Paragraph 2", type: "textarea" },
      { name: "cta_primary_label", label: "Primary CTA label", type: "text" },
      { name: "cta_primary_link", label: "Primary CTA link", type: "url" },
      { name: "cta_secondary_label", label: "Secondary CTA label", type: "text" },
      { name: "cta_secondary_link", label: "Secondary CTA link", type: "url" },
      { name: "image_url", label: "Hero image / GIF", type: "image" },
    ],
  },
  "who-we-are": {
    title: "Section 2 — Who We Are",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraphs", label: "Paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
      { name: "callout", label: "Callout box (bold statement)", type: "textarea" },
    ],
  },
  origin: {
    title: "Section 3 — Our Origin",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraphs", label: "Paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
      { name: "quote", label: "Highlighted quote (left-bordered)", type: "textarea" },
      { name: "closing", label: "Closing line", type: "textarea" },
    ],
  },
  "vision-mission": {
    title: "Section 4 — Vision & Mission",
    fields: [
      { name: "vision_title_pre", label: "Vision — title before highlight", type: "text" },
      { name: "vision_title_highlight", label: "Vision — title highlighted", type: "text" },
      { name: "vision_paragraphs", label: "Vision paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
      { name: "vision_footer", label: "Vision — footer (bold)", type: "text" },
      { name: "mission_title_pre", label: "Mission — title before highlight", type: "text" },
      { name: "mission_title_highlight", label: "Mission — title highlighted", type: "text" },
      { name: "mission_paragraph", label: "Mission paragraph", type: "textarea" },
      { name: "mission_label", label: "Mission items label", type: "text" },
      { name: "mission_items", label: "Mission focus items", type: "list", primitive: true,
        item: [{ name: "_value", label: "Item", type: "text" }] },
      { name: "mission_footer", label: "Mission footer (italic)", type: "textarea" },
    ],
  },
  believe: {
    title: "Section 6 — What We Believe",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "title_post", label: "Title — after highlight", type: "text" },
      {
        name: "cards", label: "Belief cards", type: "list",
        item: [
          { name: "icon", label: "Icon", type: "icon" },
          { name: "text", label: "Text", type: "textarea" },
        ],
      },
    ],
  },
  thinking: {
    title: "Section 7 — How We Think",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraphs", label: "Paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
      { name: "questions_label", label: "Questions label", type: "text" },
      { name: "questions", label: "Thinking questions", type: "list", primitive: true,
        item: [{ name: "_value", label: "Question", type: "text" }] },
    ],
  },
  team: {
    title: "Section 8 — Our Team",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraphs", label: "Paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
      { name: "footer", label: "Footer (bold)", type: "text" },
      { name: "skills", label: "Skill chips", type: "list", primitive: true,
        item: [{ name: "_value", label: "Skill", type: "text" }] },
    ],
  },
  "how-we-work": {
    title: "Section 9 — How We Work",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraph", label: "Paragraph", type: "textarea" },
      {
        name: "steps", label: "Process steps", type: "list",
        item: [
          { name: "num", label: "Number (e.g. '01')", type: "text" },
          { name: "title", label: "Title", type: "text" },
          { name: "desc", label: "Description", type: "textarea" },
        ],
      },
    ],
  },
  differentiators: {
    title: "Section 10 — What Makes Us Different",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      {
        name: "cards", label: "Differentiator cards", type: "list",
        item: [
          { name: "title", label: "Title", type: "text" },
          { name: "desc", label: "Description", type: "textarea" },
        ],
      },
    ],
  },
  commitment: {
    title: "Section 11 — Our Commitment",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraphs", label: "Paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
      { name: "items_label", label: "Items label", type: "text" },
      { name: "items", label: "Commitment items", type: "list", primitive: true,
        item: [{ name: "_value", label: "Item", type: "text" }] },
    ],
  },
  future: {
    title: "Section 12 — Where We Are Going",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "left_paragraphs", label: "Left column paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
      { name: "right_paragraph", label: "Right column paragraph", type: "textarea" },
      { name: "right_emphasis", label: "Right column emphasis (bold)", type: "textarea" },
    ],
  },
  "final-cta": {
    title: "Section 13 — Final CTA",
    fields: [
      { name: "title", label: "Heading", type: "textarea" },
      { name: "paragraph", label: "Paragraph", type: "textarea" },
      { name: "cta_primary_label", label: "Primary CTA label", type: "text" },
      { name: "cta_primary_link", label: "Primary CTA link", type: "url" },
      { name: "cta_secondary_label", label: "Secondary CTA label", type: "text" },
      { name: "cta_secondary_link", label: "Secondary CTA link", type: "url" },
      { name: "tagline", label: "Tagline (small text)", type: "text" },
    ],
  },
};

const CONTACT_SCHEMAS = {
  hero: {
    title: "Section 1 — Hero",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraph1", label: "Paragraph 1", type: "textarea" },
      { name: "paragraph2", label: "Paragraph 2", type: "textarea" },
      { name: "cta_label", label: "CTA label", type: "text" },
      { name: "cta_link", label: "CTA link", type: "url" },
    ],
  },
  conversation: {
    title: "Section 2 — Start the Conversation",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraph_lead", label: "Lead sentence (bold)", type: "textarea" },
      { name: "paragraph", label: "Paragraph", type: "textarea" },
      { name: "list_label", label: "List label", type: "text" },
      { name: "items", label: "Conversation items", type: "list", primitive: true,
        item: [{ name: "_value", label: "Item", type: "text" }] },
    ],
  },
  "how-we-help": {
    title: "Section 3 — How We Can Help",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraph", label: "Paragraph", type: "textarea" },
      { name: "items", label: "Service items", type: "list", primitive: true,
        item: [{ name: "_value", label: "Service", type: "text" }] },
    ],
  },
  form: {
    title: "Section 4 — Contact Form labels",
    fields: [
      { name: "heading", label: "Form heading", type: "text" },
      { name: "subheading", label: "Form subheading", type: "textarea" },
      { name: "submit_label", label: "Submit button label", type: "text" },
      { name: "success_title", label: "Success — title", type: "text" },
      { name: "success_message", label: "Success — message", type: "textarea" },
      { name: "success_button", label: "Success — button label", type: "text" },
      { name: "summary_placeholder", label: "Summary textarea placeholder", type: "textarea" },
      { name: "upload_label", label: "Upload label", type: "text" },
      { name: "inquiry_types", label: "Inquiry type options", type: "list", primitive: true,
        item: [{ name: "_value", label: "Option", type: "text" }] },
      { name: "preferred_modes", label: "Preferred mode options", type: "list", primitive: true,
        item: [{ name: "_value", label: "Option", type: "text" }] },
    ],
  },
  "contact-info": {
    title: "Section 5 — Contact Info & Offices",
    fields: [
      { name: "company_name", label: "Company name", type: "text" },
      { name: "tagline", label: "Tagline", type: "textarea" },
      { name: "email", label: "Email", type: "text" },
      { name: "phone", label: "Phone(s)", type: "text" },
      { name: "website", label: "Website (display)", type: "text" },
      { name: "website_link", label: "Website (link)", type: "url" },
      {
        name: "offices", label: "Offices", type: "list",
        item: [
          { name: "name", label: "Office name", type: "text" },
          { name: "address", label: "Address", type: "textarea" },
          { name: "map_url", label: "Google Maps embed URL", type: "url" },
        ],
      },
    ],
  },
  "strategic-partner": {
    title: "Section 6 — Strategic Partnership",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraphs", label: "Paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
      { name: "cta_label", label: "CTA label", type: "text" },
      { name: "cta_link", label: "CTA link", type: "url" },
      { name: "items", label: "Partnership items", type: "list", primitive: true,
        item: [{ name: "_value", label: "Item", type: "text" }] },
    ],
  },
  "best-fit": {
    title: "Section 7 — Who We Work Best With",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraph", label: "Paragraph", type: "textarea" },
      { name: "list_label", label: "List label", type: "text" },
      { name: "items", label: "Best-fit items", type: "list", primitive: true,
        item: [{ name: "_value", label: "Item", type: "text" }] },
    ],
  },
  "global-reach": {
    title: "Section 8 — Global Reach",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      { name: "paragraphs", label: "Paragraphs", type: "list", primitive: true,
        item: [{ name: "_value", label: "Paragraph", type: "textarea" }] },
    ],
  },
  "what-happens": {
    title: "Section 9 — What Happens After",
    fields: [
      { name: "overline", label: "Overline", type: "text" },
      { name: "title_pre", label: "Title — before highlight", type: "text" },
      { name: "title_highlight", label: "Title — highlighted", type: "text" },
      {
        name: "steps", label: "Process steps", type: "list",
        item: [
          { name: "num", label: "Number (e.g. '01')", type: "text" },
          { name: "title", label: "Title", type: "text" },
          { name: "desc", label: "Description", type: "textarea" },
        ],
      },
    ],
  },
  "final-cta": {
    title: "Section 10 — Final CTA",
    fields: [
      { name: "title", label: "Heading", type: "textarea" },
      { name: "paragraph", label: "Paragraph", type: "textarea" },
      { name: "cta_primary_label", label: "Primary CTA label", type: "text" },
      { name: "cta_primary_link", label: "Primary CTA link", type: "url" },
      { name: "cta_secondary_label", label: "Secondary CTA label", type: "text" },
      { name: "cta_secondary_link", label: "Secondary CTA link", type: "url" },
      { name: "tagline", label: "Tagline (small text)", type: "text" },
    ],
  },
};

const FOOTER_SCHEMAS = {
  brand: {
    title: "Section 1 — Brand & Registered Office",
    fields: [
      { name: "logo_url", label: "Logo / GIF", type: "image" },
      { name: "logo_alt", label: "Logo alt text", type: "text" },
      { name: "description", label: "Short description", type: "textarea" },
      { name: "office_label", label: "Office label (e.g. Registered Office)", type: "text" },
      { name: "office_address", label: "Registered office address", type: "lines" },
      { name: "cta_label", label: "CTA label", type: "text" },
      { name: "cta_link", label: "CTA link", type: "url" },
    ],
  },
  explore: {
    title: "Section 2 — Explore (navigation links)",
    fields: [
      { name: "heading", label: "Column heading", type: "text" },
      {
        name: "links", label: "Links", type: "list",
        item: [
          { name: "label", label: "Label", type: "text" },
          { name: "to", label: "Path (e.g. /about) or full URL", type: "text" },
        ],
      },
    ],
  },
  contact: {
    title: "Section 3 — Get in Touch",
    fields: [
      { name: "heading", label: "Column heading", type: "text" },
      { name: "addresses", label: "Office addresses", type: "list", primitive: true,
        item: [{ name: "_value", label: "Address", type: "textarea" }] },
      { name: "email", label: "Email", type: "text" },
      { name: "phone", label: "Phone(s)", type: "text" },
      { name: "website_label", label: "Website (display)", type: "text" },
      { name: "website_link", label: "Website (link)", type: "url" },
    ],
  },
  bottom: {
    title: "Section 4 — Bottom Bar (seal, copyright, socials)",
    fields: [
      { name: "seal_image", label: "D-U-N-S seal image", type: "image" },
      { name: "seal_link", label: "D-U-N-S seal link", type: "url" },
      { name: "seal_alt", label: "D-U-N-S seal alt text", type: "text" },
      { name: "copyright", label: "Copyright line (use {year} for the current year)", type: "text" },
      { name: "tagline", label: "Tagline (right side)", type: "text" },
      {
        name: "socials", label: "Social links", type: "list",
        item: [
          { name: "platform", label: "Platform (Facebook, Instagram, YouTube, LinkedIn, WhatsApp, X, Website)", type: "text" },
          { name: "href", label: "URL", type: "url" },
        ],
      },
    ],
  },
};

const PAGE_SCHEMAS = {
  home: HOME_SCHEMAS,
  about: ABOUT_SCHEMAS,
  contact: CONTACT_SCHEMAS,
  footer: FOOTER_SCHEMAS,
};

const PAGE_LABELS = {
  home: "Home Page",
  about: "About Page",
  contact: "Contact Page",
  footer: "Footer (site-wide)",
};

export { PAGE_SCHEMAS, PAGE_LABELS, ICON_OPTIONS };
